import { Col, Row } from "antd";

import styles from "./InstructionHintContent.module.css";

export const ActionListItem = ({ icon, description }) => {
  return (
    <Row>
      <Col span={3}>
        <div className={styles.center}>{icon}</div>
      </Col>
      <Col span={21}>
        <p>{description}</p>
      </Col>
    </Row>
  );
};
